type Props = {
  baseLocale: string;
  allLocales: string[];
  visible: Set<string>;
  onToggle: (locale: string) => void;
  /** locale → main から変更されたセル数。0 / 未指定はバッジなし。非表示 locale でも変更有無が分かる */
  changedCountByLocale?: Map<string, number>;
};

/**
 * 言語ピル: baseLocale は固定で常時 ON、それ以外はクリックで toggle。
 * main から変更がある locale にはバッジで件数を出す。
 */
export const LocaleSelector = ({
  baseLocale,
  allLocales,
  visible,
  onToggle,
  changedCountByLocale,
}: Props) => (
  <div className="flex flex-wrap items-center gap-1 text-xs">
    <span className="mr-1 text-gray-500">表示する言語:</span>
    {allLocales.map((locale) => {
      const isBase = locale === baseLocale;
      const isOn = isBase || visible.has(locale);
      const changed = changedCountByLocale?.get(locale) ?? 0;
      return (
        <button
          key={locale}
          type="button"
          onClick={() => {
            if (!isBase) onToggle(locale);
          }}
          disabled={isBase}
          className={`rounded border px-2 py-0.5 ${
            isOn
              ? 'border-gray-900 bg-gray-900 text-white'
              : 'border-gray-300 bg-white text-gray-500'
          } ${isBase ? 'cursor-default' : 'hover:border-gray-500'}`}
        >
          {locale}
          {isBase && <span className="ml-1 text-[10px] opacity-70">base</span>}
          {changed > 0 && (
            <span
              title={`main から ${changed.toString()} 件変更`}
              className={`ml-1 inline-flex items-center gap-0.5 rounded-full px-1 text-[10px] font-semibold ${
                isOn ? 'bg-amber-400 text-amber-950' : 'bg-amber-100 text-amber-800'
              }`}
            >
              <span className="h-1 w-1 rounded-full bg-current opacity-80" />
              {changed}
            </span>
          )}
        </button>
      );
    })}
  </div>
);
